import React from "react";
import AppRoutes from "./routes/AppRoutes";
import Toaster from "./components/Toaster/Toaster";

const App = () => {
  return (
    <>
      <Toaster />
      <AppRoutes />
    </>
  );
};

export default App;
